import { z } from "zod";

export type TWorkspaceStatus =
  | "pending"
  | "active"
  | "expired"
  | "grace_period"
  | "archived"
  | "suspended";

export type TWorkspacePlan = "trial" | "starter" | "paid";

export type TWorkspaceRole = "admin" | "member";

export const WorkspaceSchema = z.object({
  id: z.string(),
  name: z.string(),
  logo: z.string().nullable(),
  industry: z.string(),
  company: z.string(),
  description: z.string().nullable(),
  slug: z.string(),
  status: z
    .enum([
      "pending",
      "active",
      "expired",
      "grace_period",
      "archived",
      "suspended",
    ])
    .catch("active"),
  country: z.string().optional().nullable(),
  company_size: z.string().optional().nullable(),
  size: z.number().optional(),
  is_suspended: z.boolean(),
  suspension_reason: z.string().nullable(),
  admin_email: z.string().nullable().catch(null),
});

export type TWorkspace = z.infer<typeof WorkspaceSchema>;
